import client from 'src/utils/api/client';
import { GET_OBJECT_PRE_SIGNED_URL } from 'src/graphql/attachment/query';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import logger from 'src/utils/logger';

const defaultOptions = {
  namingFn: null,
  zippingFn: null,
  zipFolderName: null,
  zipFileName: 'attachments',
  putExtra: false,
  extras: []
};

export default async (attachmentsData = [], options = defaultOptions) => {
  const filenameMap = new Map();

  const getPreSignedUrl = async (id, realName) => {
    try {
      const response = await client.query({
        query: GET_OBJECT_PRE_SIGNED_URL,
        variables: realName ? {
          id,
          realName,
        } : { id },
      });
      return response.data.getObjectPreSignedUrl.url;
    } catch (err) {
      logger.error('Caught', err);
      return null;
    }
  };

  const dataWithBlob = await Promise.all(
    attachmentsData.map(
      async (attachment) => {
        const url = await getPreSignedUrl(attachment.attId, attachment.name);
        if (url) {
          const response = await fetch(url);
          const blob = await response.blob();
          const fileExtension = attachment?.name?.split('.').pop();
          const fileExtensionIndex = attachment?.name?.lastIndexOf(fileExtension);
          const attachmentNameWithoutExtension = attachment?.name?.slice(0, fileExtensionIndex - 1);
          const mapKeyName = `${attachment.actionReference}_${attachmentNameWithoutExtension}.${fileExtension}`;
          if (filenameMap.has(mapKeyName)) {
            const filenameCount = filenameMap.get(mapKeyName);
            filenameMap.set(mapKeyName, filenameCount + 1);
            // eslint-disable-next-line no-param-reassign
            attachment.name = `${attachment.actionReference}_${attachmentNameWithoutExtension} (${filenameCount}).${fileExtension}`;
          } else {
            filenameMap.set(mapKeyName, 1);
            // eslint-disable-next-line no-param-reassign
            attachment.name = mapKeyName;
          }
          return { ...attachment, blob };
        }
        return null;
      },
    ));

  const zip = new JSZip();
  const folder = zip.folder(null);
  dataWithBlob.filter(data => !!data).forEach(d => {
    if(options.zipFolderName) {
      folder.file(`${options.zipFolderName}/${d.name}`, d.blob);
    }else{
      folder.file(d.name, d.blob);
    }
  });

  if(options.putExtra) {
    options.extras.forEach(extra =>{
      folder.file(extra.name, extra.blobData);
    });
  }

  const content = await folder.generateAsync({ type: 'blob' });

  saveAs(content, options.zipFileName);

  return true;

};
